import { api } from 'src/boot/axios.js';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';
import actions from '../../lib/api/actions';
import RoleService from '../../lib/api/role.service';
import UserService from '../../lib/api/user.service';

export async function initializeUser({ dispatch }) {
  if (LocalStorage.has('user')) {
    const { accessToken } = LocalStorage.getItem('user');
    await dispatch('setUserAccessToken', accessToken);
    await dispatch('fetchUserInformation');
    await dispatch('fetchUserPaymentMethod');
    await dispatch('fetchUserItems');
  }
}

export function setUserAccessToken({ commit }, accessToken) {
  if (accessToken) {
    commit('updateLoggedIn', true);
    api.defaults.headers.common['X-Access-Token'] = accessToken;
  }
}

export function saveUserPushToken({ state }) {
  if (state.pushToken) {
    actions.saveUserPushToken(state.pushToken);
  }
}

export async function authenticateUser({ commit, dispatch }, payload) {
  const response = await actions.authenticateUser(payload);

  if (response.status === 200) {
    if (response.data.data) {
      commit('updateUser', response.data.data);

      /*
      if (!response.data.data.isInternal) {
        commit('storeUserInLocalStorage');
      }
       */

      dispatch('setUserAccessToken', response.data.data.accessToken);
      dispatch('location/fetchDeliveryMethods', null, { root: true });
      await dispatch('fetchUserPaymentMethod');
      await dispatch('fetchUserItems');
    }
  }
}

export async function fetchUserInformation({ commit, dispatch }) {
  const response = await actions.fetchUserInformation();

  if (response.status === 200) {
    commit('updateUser', response.data);
    commit('storeUserInLocalStorage');
    dispatch('setUserAccessToken', response.data.accessToken);
  }
}

export async function fetchUserByUUID({ commit, dispatch }, { uuid }) {
  const response = await UserService.get({ uuid });

  if (response.status === 200) {
    commit('updateUser', response.data);
    commit('storeUserInLocalStorage');
    dispatch('setUserAccessToken', response.data.accessToken);
  }
}

export async function fetchAllOrders({ commit }) {
  const response = await actions.fetchAllOrdersFromAPI();

  if (response.status === 200) {
    commit('updateAllOrders', response.data);
  }
}

export async function saveUserAddress({ commit }, payload) {
  const response = await actions.saveUserAddress(payload);

  if (response.status === 200) {
    const userResponse = await actions.fetchUserInformation();
    if (userResponse.status === 200) {
      commit('updateUser', userResponse.data);
    }
  }
}

export async function updateUserAddress({ commit }, payload) {
  const response = await actions.updateUserAddress(payload);

  if (response.status === 200) {
    const userResponse = await actions.fetchUserInformation();
    if (userResponse.status === 200) {
      commit('updateUser', userResponse.data);
    }
  }
}

export async function updateUserDefaultAddress({ commit }, payload) {
  const response = await actions.updateUserDefaultAddress(payload);

  if (response.status === 200) {
    const userResponse = await actions.fetchUserInformation();
    if (userResponse.status === 200) {
      commit('updateUser', userResponse.data);
    }
  }
}

export async function deleteUserAddress({ commit }, payload) {
  const response = await actions.deleteUserAddress(payload);

  if (response.status === 200) {
    const userResponse = await actions.fetchUserInformation();
    if (userResponse.status === 200) {
      commit('updateUser', userResponse.data);
    }
  }
}

export async function logOut({ commit, dispatch }) {
  commit('flush');
  commit('updateLoggedIn', false);
  commit('removeUserFromLocalStorage');
  dispatch('order/flush', null, { root: true });
}

export async function fetchUserPaymentMethod({ commit }) {
  const response = await actions.fetchUserPaymentMethod();

  if (response.status === 200) {
    commit('setUserPaymentMethod', response.data);
  }
}

export async function saveNewPaymentMethod({ commit }, payload) {
  const response = await actions.saveNewUserPaymentMethod(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('setUserPaymentMethod', response.data.data);
    }
  }
}

export async function removeUserPaymentMethodById({ commit }, payload) {
  const response = await actions.removeUserPaymentMethodById(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('setUserPaymentMethod', response.data.data);
    }
  }
}

export async function updateUserDefaultPaymentMethod({ commit }, payload) {
  const response = await actions.updateUserDefaultPaymentMethod(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('setUserPaymentMethod', response.data.data);
    }
  }
}

export async function updateUserSettings({ commit }, payload) {
  const response = await actions.saveUserSettings(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('updateUserSettings', response.data.data);
      commit('storeUserInLocalStorage');
    }
  }
}

export async function fetchUserItems({ commit }) {
  const response = await actions.fetchUserItems();

  if (response.status === 200) {
    commit('setUserItems', response.data);
  }
}

export async function saveUserItem({ commit }, payload) {
  const response = await actions.saveUserItem(payload);

  if (response.status === 200) {
    commit('setUserItems', response.data);
  }

  return response;
}

export async function removeUserItem({ commit }, payload) {
  const response = await actions.removeUserItem(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('setUserItems', response.data.data);
    }
  }
}

export async function updateUserItem({ commit }, payload) {
  const response = await actions.updateUserItem(payload);

  if (response.status === 200) {
    if (response.data.success) {
      commit('setUserItems', response.data.data);
    }
  }
}

export async function fetchAllUsers({ commit }, { roleId }) {
  const response = await RoleService.get(roleId);
  if (response.status === 200) {
    commit('updateAllUsers', { users: response.data.users });
  }
}
